import styled, { css } from 'styled-components';
import StyledBtnGeneric from './StyledBtnGeneric';
import withButtonProps from './withButtonProps';

const cssLarge = css`
  --btn-height: 110px;
  
  padding: 0px 50px 3px;
  height: var(--btn-height);
  line-height: var(--btn-height);
  font-size: 50px;
  box-shadow: inset 0px 3px 0px ${props => props.highlightColor},
    inset 0px -3px 0px ${props => props.shadowColor};
  text-shadow: 0px 3px 0px ${props => props.shadowColor};

  svg {
    margin-bottom: 9px;
    filter: drop-shadow(0px 3px 0px ${props => props.shadowColor});
  }
`;

const cssMedium = css`
  --btn-height: 84px;
  
  padding: 0px 38px 0px;
  height: var(--btn-height);
  line-height: var(--btn-height);
  font-size: 40px;
  box-shadow: inset 0px 2px 0px ${props => props.highlightColor},
    inset 0px -2px 0px ${props => props.shadowColor};
  text-shadow: 0px 2px 0px ${props => props.shadowColor};

  svg {
    margin-bottom: 6px;
    filter: drop-shadow(0px 2px 0px ${props => props.shadowColor});
  }
`;

const cssSmall = css`
  --btn-height: 66px;
  
  padding: 0px 24px 0px;
  height: var(--btn-height);
  line-height: var(--btn-height);
  font-size: 28px;
  box-shadow: inset 0px 2px 0px ${props => props.highlightColor},
    inset 0px -2px 0px ${props => props.shadowColor};
  text-shadow: 0px 2px 0px ${props => props.shadowColor};

  svg {
    margin-bottom: 6px;
    filter: drop-shadow(0px 2px 0px ${props => props.shadowColor});
  }
`;

const cssBySize = {
  large: cssLarge,
  medium: cssMedium,
  small: cssSmall,
};

const iconSizes = {
  large: 'xl',
  medium: 'large',
  small: 'medium',
};

const StyledLowProfile = styled(StyledBtnGeneric)`
  ${props => cssBySize[props.size]}

  ${props =>
    props.invert &&
    css`
      text-shadow: none;
      
      svg {
       filter: none;
      }
    `}
`;

export default withButtonProps(StyledLowProfile, { iconSizes });
